import { useEffect, useState } from 'react';
import { getAllNews } from '../../../providers/apis/blogApi';
import { getNewsGraphic2Url, resolveContentMedia } from '../../../pages/new/helper/graphic2';
import { HubFeatureCard } from '../../../pages/new/layout/HubFeatureCard';
import { HubListingView } from '../../../pages/new/layout/HubListingView';
import { useFilteredHubListing } from '../../../pages/new/layout/useFilteredHubListing';

function parseNews(newsRes) {
  return newsRes.map((nItem) => ({
    postId: nItem.Id,
    title: nItem.Title,
    postMedia: resolveContentMedia(nItem, getNewsGraphic2Url),
    postDate: nItem.DatePublished,
    postType: nItem.ContentType || 'news',
    postName: nItem.Relevance,
    link: nItem.Source,
    hasBody: nItem.hasBody,
    content: nItem.Description,
  }));
}

export const NewsTabContent = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    query,
    hasQuery,
    matchCount,
    firstItem,
    pageItems,
    totalPages,
    currentPage,
    onPageChange,
  } = useFilteredHubListing(items);

  useEffect(() => {
    const loadAllNews = async () => {
      setLoading(true);
      try {
        const newsRes = await getAllNews();
        setItems(parseNews(newsRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadAllNews();
  }, []);

  const renderFeatured = (item) => <HubFeatureCard firstBlog={item} />;

  return (
    <HubListingView
      title="News"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
      hasQuery={hasQuery}
      query={query}
      matchCount={matchCount}
    />
  );
};
